import {
  CHECK_EMAIL_MESSAGE,
  CHECK_EMAIL_TITLE,
} from '../../constants/ui.labels'
import ContentHeader from '../ContentHeader'
import { useTheme } from '@talkdesk/cobalt-react-theme-provider'
import IconWithProvider from '@talkdesk/cobalt-react-icon'
import Flex from '@talkdesk/cobalt-react-flex'

const CheckEmail = () => {
  const theme = useTheme()
  return (
    <Flex direction='column' alignX='center'>
      <Flex direction='column' alignX='center' padding='4' gap='2'>
        <IconWithProvider
          name='mail_outline'
          size='large'
          color={theme.gray600}
        />
        <ContentHeader
          title={CHECK_EMAIL_TITLE}
          message={CHECK_EMAIL_MESSAGE}
        />
      </Flex>
    </Flex>
  )
}

export default CheckEmail
